export const getSurvey = (userId) => {
  return ["survey", userId];
};

export const getSurveys = (userId) => {
  return ["surveys", userId];
};